<div
    [ngClass]="hasLightCopyright() ? 'copyright-block-light' : 'copyright-block'"
    [attr.data-testid]="'copyright-block'">
    <span i18n hSrOnlyNoSnippet>Copyright</span>
    <p [ngClass]="hasLightCopyright() ? 'paragraph-small' : 'paragraph-xsmall'" class="copyright">
        <ng-container i18n="@@hermes_footer.all-right-reserved">
            &copy; Hermès {{ year }}. All rights reserved.
        </ng-container>
    </p>

    @if (isKorea && hasLightCopyright()) {
        <ul id="korea-copyright">
            <h-korean-legal-links [hasLightCopyright]="true"></h-korean-legal-links>
        </ul>
    }
</div>
